import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgAlert = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 64 64"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="hsl(var(--system-icon-background-alert))"
        d="M59.976 5.776c-23.96-8.65-46.853-3.604-55.547 0-8.021 23.667-3.342 45.442 0 53.371 23.783 8.79 46.78 3.662 55.547 0 7.288-22.036 3.037-44.762 0-53.37"
      />
      <path
        fill="hsl(var(--system-icon-white))"
        d="M18.002 48.644h28.36a4.073 4.073 0 0 0 3.563-5.601L35.674 18.106a4.07 4.07 0 0 0-7.128 0L14.299 43.045a4.074 4.074 0 0 0 3.562 5.599"
      />
      <path
        fill="hsl(var(--system-icon-foreground))"
        d="M32.11 14.625a5.45 5.45 0 0 1 4.756 2.798h.002l14.25 24.937q.045.08.08.165a5.45 5.45 0 0 1-4.764 7.492l-.072.002h-28.36q-.028-.002-.056-.003a1 1 0 0 1-.157 0 5.448 5.448 0 0 1-4.765-7.488l.08-.165 14.248-24.94a5.45 5.45 0 0 1 4.757-2.798m0 2.75a2.7 2.7 0 0 0-2.36 1.395l-.01.017-14.192 24.84a2.698 2.698 0 0 0 2.385 3.643h.008l.061-.001h28.314a2.7 2.7 0 0 0 2.522-2.45 2.7 2.7 0 0 0-.16-1.186L34.48 18.788l-.011-.018a2.7 2.7 0 0 0-2.36-1.395"
      />
      <path
        fill="hsl(var(--system-icon-foreground))"
        d="M31 40.64c0-.761.616-1.386 1.375-1.386s1.375.605 1.375 1.366v.018a1.375 1.375 0 1 1-2.75 0zM31.074 35.071V29a1.375 1.375 0 1 1 2.75 0v6.071a1.375 1.375 0 0 1-2.75 0"
      />
    </svg>
  );
};
export default SvgAlert;
